// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-editor {
  position: relative;
  overflow: hidden;
}
.text-editor .switch-menu {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 0.25rem;
}
.text-editor .switch-menu .switch-mode {
  display: none;
}
.text-editor .switch-menu:hover i {
  display: none;
}
.text-editor .switch-menu:hover .switch-mode {
  display: block;
}
.text-editor .CodeMirror {
  height: auto;
}
.text-editor .CodeMirror-scroll, .text-editor .CodeMirror-vscrollbar {
  /*-50px by default. Increasing it so it's completely out of view.*/
  margin-right: -70px;
}

.vue-codemirror .CodeMirror-vscrollbar {
  /*-50px by default. Increasing it so it's completely out of view.*/
  margin-right: -70px;
}

.CodeMirror-hints, .CodeMirror-lint-tooltip {
  z-index: 1000 !important;
}`, "",{"version":3,"sources":["webpack://./src/editor/editor.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,gBAAA;AACD;AACC;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AACF;AACQ;EACE,aAAA;AACV;AAEE;EACC,aAAA;AAAH;AAGE;EACI,cAAA;AADN;AAKC;EACC,YAAA;AAHF;AAMC;EACC,kEAAA;EACA,mBAAA;AAJF;;AASC;EACC,kEAAA;EACA,mBAAA;AANF;;AAUA;EACE,wBAAA;AAPF","sourcesContent":[".text-editor {\n\tposition: relative;\n\toverflow: hidden;\n\n\t.switch-menu {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tmargin-right: 0.25rem;\n\n        .switch-mode {\n          display: none;\n        }\n\n\t\t&:hover i{\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t&:hover .switch-mode {\n\t\t    display: block;\n\t\t}\n\t}\n\n\t.CodeMirror {\n\t\theight: auto;\n\t}\n\n\t.CodeMirror-scroll, .CodeMirror-vscrollbar {\n\t\t/*-50px by default. Increasing it so it's completely out of view.*/\n\t\tmargin-right: -70px\n\t}\n}\n\n.vue-codemirror {\n\t.CodeMirror-vscrollbar {\n\t\t/*-50px by default. Increasing it so it's completely out of view.*/\n\t\tmargin-right: -70px\n\t}\n}\n\n.CodeMirror-hints, .CodeMirror-lint-tooltip {\n  z-index: 1000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
